import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mt-10" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("发布")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("审批通过")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("批量取消删除")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("批量取消审批")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确认审批通过")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("批量取消删除")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("批量取消审批")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix, { userCfig } from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import { formatTime, formatNumber, getNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  // 获取所有员工绩效
  'POST/user_achievements/list': fetchList,
  // 发布-批量发布奖惩绩效
  'POST/user_achievements/batch_publish': achievementsPublishApi,
  // 修改-奖惩绩效
  'PATCH/user_achievements': achievementsModifyApi,
  // 删除-奖惩绩效
  'DELETE/user_achievements/{id}': achievementsDelApi,
  // 批量审批通过
  'PATCH/user_achievements/confirm': confirmApi,
  // 批量取消删除
  'PATCH/user_achievements/cancelDelete': cancelDeleteApi,
  // 批量取消审批
  'PATCH/user_achievements/cancelConfirm': cancelConfirmApi,
} = Api

const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const achieveElement = ref()
let achieveRows: any = ref([])
const searchConfig = ref([
  {
    label: '发布人',
    value: '',
    upKey: 'publisher'
  },
  {
    label: '批准人',
    value: '',
    upKey: 'approver'
  },
  {
    type: 'SELECT',
    label: '状态',
    value: '',
    upKey: 'status',
    options: [
      { label: '待审核', id: 'Pending' },
      { label: '通过', id: 'Completed' },
      { label: '关闭', id: 'Closed' },
    ],
    props: { clearable: true, placeholder: '请选择状态', },
    seleProps: {
      label: 'label',
      valueName: 'id',
    }
  },
  {
    label: '员工',
    value: '',
    upKey: 'owner'
  },
  {
    type: "TIME",
    label: "发布日期",
    value: '',
    upKey: 'publishDate',
    upProps: { includeKey: 'publishAt' },
    props: {
      type: 'daterange',
      'value-format': 'YYYY-MM-DD',
      clearable: true
    }
  },
  {
    type: "TIME",
    label: "批复日期",
    value: '',
    upKey: 'approvalDate',
    upProps: { includeKey: 'approvalAt' },
    props: {
      type: 'daterange',
      'value-format': 'YYYY-MM-DD',
      clearable: true
    }
  },
])
// 添加
const addConfig: any = ref([
  userCfig({
    upKey: 'userIds',
    value: [],
    props: { multiple: true, 'collapse-tags': true, style: 'width: 300px' },
    rule: [{ required: true, message: '请选择员工', trigger: 'change' }]
  }),
  {
    type: 'SELECT',
    label: '方式',
    value: '',
    upKey: 'means',
    options: [
      { label: '火花', id: '火花' },
      { label: '现金', id: '现金' },
    ],
    props: { clearable: true, placeholder: '请选择方式', },
    seleProps: { label: 'label', valueName: 'id' }
  },
  {
    label: '数量',
    value: '',
    upKey: 'quantity'
  },
  {
    type: 'SELECT',
    label: '方式',
    value: '',
    upKey: 'operate',
    options: [
      { label: '增加', id: true },
      { label: '减少', id: false },
    ],
    props: { clearable: true, placeholder: '请选择方式', },
    seleProps: { label: 'label', valueName: 'id' }
  },
  {
    label: '描述',
    value: '',
    upKey: 'content',
    props: { type: 'textarea', style: 'width: 555px', placeholder: '请输入描述', rows: 4, maxlength: 500 }
  },


])
const addFg = ref<boolean>(false)
const addHandle = () => {
  MI_modifyForm({userIds: []}, addConfig, addFg, async (params: any) => {
    await achievementsPublishApi(params)
    ElMessage.success('发布成功')
    addFg.value = false
    fetchData(MI_params)
  })
}

// 修改
const modifyConfig: any = ref([
  userCfig({
    upKey: 'userId',
    value: '',
    props: { disabled: true, style: 'width: 300px' },
  }),
  {
    type: 'SELECT',
    label: '方式',
    value: '',
    upKey: 'means',
    options: [
      { label: '火花', id: '火花' },
      { label: '现金', id: '现金' },
    ],
    props: { clearable: true, placeholder: '请选择方式', },
    seleProps: { label: 'label', valueName: 'id' }
  },
  {
    label: '数量',
    value: '',
    upKey: 'quantity'
  },
  {
    type: 'SELECT',
    label: '方式',
    value: '',
    upKey: 'operate',
    options: [
      { label: '增加', id: true },
      { label: '减少', id: false },
    ],
    props: { clearable: true, placeholder: '请选择方式', },
    seleProps: { label: 'label', valueName: 'id' }
  },
  {
    label: '描述',
    value: '',
    upKey: 'content',
    props: { type: 'textarea', style: 'width: 555px', placeholder: '请输入描述', rows: 4, maxlength: 500 }
  },


])
const modifyFg = ref<boolean>(false)
const modifyHandle = (row: any) => {
  MI_modifyForm(row, modifyConfig, modifyFg, async (params: any) => {
    await achievementsModifyApi({
      ...params,
      id: row.id
    })
    ElMessage.success('修改成功')
    modifyFg.value = false
    fetchData(MI_params)
  })
}

// 删除
const delHandle = (row: any) => {
  ElMessageBox.confirm(
    '是否确认删除?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      MI_identify.value = true
      return achievementsDelApi({ id: row.id })
    })
    .then(() => {
      MI_identify.value = false
      ElMessage.success('删除成功')
      fetchData(MI_params)
    })
    .catch(() => {
      MI_identify.value = false
    })

}


// 0: 审批通过; 1: 取消删除; 2: 取消审批
let mutipleBtnLoadFg = ref<boolean>(false)
let mutipleType = ref<string>('0')
const multipleTableFg: any = ref(false)

// 批量审批通过
const confirmHandle = () => {
  mutipleBtnLoadFg.value = true
  confirmApi({ids: achieveRows.value.map((e: any) => e.id)}).then(() => {
    ElMessage.success('批量审批通过成功')
    mutipleBtnLoadFg.value = false
    multipleTableFg.value = false
    achieveElement.value.clearSelection()
    fetchData(MI_params)
  }).catch(() => {
    mutipleBtnLoadFg.value = false
  })
}
// 批量取消删除
const cancelDelHandle = () => {
  mutipleBtnLoadFg.value = true
  cancelDeleteApi({ids: achieveRows.value.map((e: any) => e.id)}).then(() => {
    ElMessage.success('批量取消删除成功')
    mutipleBtnLoadFg.value = false
    multipleTableFg.value = false
    achieveElement.value.clearSelection()
    fetchData(MI_params)
  }).catch(() => {
    mutipleBtnLoadFg.value = false
  })
}
// 批量取消审批
const cancelApprover = () => {
  mutipleBtnLoadFg.value = true
  cancelConfirmApi({ids: achieveRows.value.map((e: any) => e.id)}).then(() => {
    ElMessage.success('批量取消审批成功')
    mutipleBtnLoadFg.value = false
    multipleTableFg.value = false
    achieveElement.value.clearSelection()
    fetchData(MI_params)
  }).catch(() => {
    mutipleBtnLoadFg.value = false
  })
}



return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "绩效管理搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, {
              onSearchFn: _cache[0] || (_cache[0] = ($event: any) => (_unref(fetchData)($event, {}, 1)))
            }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_1,
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (addHandle())),
      type: "primary"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })), [
      [_directive_permission, 'Write']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      onClick: _cache[2] || (_cache[2] = ($event: any) => {_isRef(mutipleType) //@ts-ignore
 ? mutipleType.value = '0' : mutipleType = '0'; multipleTableFg.value = true}),
      type: "success"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })), [
      [_directive_permission, 'Write']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      onClick: _cache[3] || (_cache[3] = ($event: any) => {_isRef(mutipleType) //@ts-ignore
 ? mutipleType.value = '1' : mutipleType = '1'; multipleTableFg.value = true}),
      type: "danger",
      plain: ""
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    })), [
      [_directive_permission, 'Write']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      onClick: _cache[4] || (_cache[4] = ($event: any) => {_isRef(mutipleType) //@ts-ignore
 ? mutipleType.value = '2' : mutipleType = '2'; multipleTableFg.value = true}),
      type: "primary",
      plain: ""
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    })), [
      [_directive_permission, 'Write']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref_key: "achieveElement",
      ref: achieveElement,
      border: "",
      class: "mt-10",
      onSelectionChange: _cache[5] || (_cache[5] = (rows) => _isRef(achieveRows) //@ts-ignore
 ? achieveRows.value = rows : achieveRows = rows),
      "row-key": "id",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55",
          fixed: "",
          "reserve-selection": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "员工",
          prop: "employeeName"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.employeeName + ' (' + row.employeeAlias + ')'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "方式",
          prop: "means",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "描述",
          prop: "content",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "奖励",
          prop: "quantity",
          align: "right",
          formatter: (row) => row.operate === true ? row.quantity.toLocaleString() : ''
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "处罚",
          prop: "quantity",
          align: "right",
          formatter: (row) => row.operate === false ? row.quantity.toLocaleString() : ''
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "审核状态",
          prop: "status",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", null, _toDisplayString(row.status === 'Pending' ? '待审核' : row.status === 'Completed' ? '通过': '关闭'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "发布人",
          prop: "publisherName"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.publisherName + ' (' + row.publisherAlias + ')'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "发布日期",
          prop: "publishAt",
          "show-overflow-tooltip": "",
          formatter: (row) => _unref(dayjs)(row.publishAt).format('YYYY-MM-DD')
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "批准人",
          prop: "approverName"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(( row.approverName || '') + ' (' + (row.approverAlias || '-') + ')'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "批准日期",
          prop: "approvalAt",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (modifyHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  type: "danger",
                  onClick: ($event: any) => (delHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50, 100, 300],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "发布绩效",
      modelValue: addFg.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((addFg).value = $event))
    }, {
      default: _withCtx(() => [
        (addFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
        searchConfig: addConfig.value,
        submitText: '确定'
      })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "修改绩效",
      modelValue: modifyFg.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((modifyFg).value = $event))
    }, {
      default: _withCtx(() => [
        (modifyFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
        searchConfig: modifyConfig.value,
        submitText: '确定'
      })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "列表多选操作",
      modelValue: multipleTableFg.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((multipleTableFg).value = $event))
    }, {
      footer: _withCtx(() => [
        (_unref(mutipleType) === '0')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              loading: _unref(mutipleBtnLoadFg),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (confirmHandle())),
              type: "success"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true),
        (_unref(mutipleType) === '1')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              loading: _unref(mutipleBtnLoadFg),
              onClick: _cache[11] || (_cache[11] = ($event: any) => (cancelDelHandle())),
              type: "danger",
              plain: ""
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true),
        (_unref(mutipleType) === '2')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              loading: _unref(mutipleBtnLoadFg),
              onClick: _cache[12] || (_cache[12] = ($event: any) => (cancelApprover())),
              type: "primary",
              plain: ""
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          border: "",
          data: _unref(achieveRows),
          "max-height": 500 + 'px'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "员工",
              prop: "employeeName"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.employeeName + ' (' + row.employeeAlias + ')'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "方式",
              prop: "means",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "奖励",
              prop: "quantity",
              align: "right",
              formatter: (row) => row.operate === true ? _unref(getNumber)(row.quantity) : ''
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "处罚",
              prop: "quantity",
              align: "right",
              formatter: (row) => row.operate === false ? _unref(getNumber)(row.quantity) : ''
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})